export default "__VITE_ASSET__5bea2761__"